<div [@slideInAnimation] class="location-warehouse-app-scanner-devices p-6">
  <div
    class="overlay"
    lumAppLoader
    [loading]="loading || false"
    [classes]="'loading blur'"
  ></div>

  <div class="flex flex-column align-items-center">
    <div class="app-option flex flex-column align-items-center">
      <img
        class="app-option__image mb-4"
        src="./assets/images/scanner.png"
        alt="qr-code-image"
      />

      <div class="selected-device" *ngIf="selectedDevice">
        <div class="text-center mat-h3">Active Device</div>
        <div class="text-center mat-headline">
          {{ selectedDevice?.label }}
          <a
            href="javascript:;"
            (click)="showDevicesList = !showDevicesList"
            title="Show / hide device list"
          >
            <small>
              <span *ngIf="!showDevicesList"> Change</span>
              <span *ngIf="showDevicesList"> Hide List</span>
            </small>
          </a>
        </div>
      </div>
      <div class="text-center mat-headline" *ngIf="!selectedDevice">
        {{ title }}
      </div>
    </div>

    <div *ngIf="showDevicesList && devices?.length" class="app-devices w-100">
      <mat-radio-group
        aria-label="Select an option"
        [(ngModel)]="currentDeviceId"
        (ngModelChange)="onSelectedDeviceIdChange($event)"
      >
        <div
          *ngFor="let device of devices; let i = index"
          class="app-device flex align-items-center p-3 mb-4"
        >
          <div class="app-device__name grow mat-h3">{{ device?.label }}</div>
          <mat-radio-button [value]="device?.deviceId"></mat-radio-button>
        </div>
      </mat-radio-group>
    </div>

    <ngx-scanner-qrcode
      class="mb-4"
      #scanner
      [config]="scannerConfig"
    ></ngx-scanner-qrcode>

    <button
      class="lum-button lum-button--large w-100"
      [routerLink]="['/warehouse-mobile-app/location-scan']"
      [queryParams]="{ deviceId: currentDeviceId }"
    >
      Open Scanner
    </button>

    <div class="ui-custom-divider mt-4">
      <span>or</span>
    </div>

    <button
      class="lum-button lum-button--large w-100"
      (click)="onOpenBarcodeDialog()"
    >
      Open Barcode Scanner
    </button>
  </div>
</div>
